import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1029"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.038 10.942h.152l.046.145c.032.106.076.2.111.302l1.385.495-.165-2.127-2.512-1.405c-.038.169-.069.35-.069.54 0 1.135.473 2.05 1.052 2.05zM4.657 9.12a.967.967 0 0 1 .758-.433c.87-.065 2.156-.154 2.726-.153.544.001 1.763.087 2.602.151a.972.972 0 0 1 .751.423l2.61-1.461c.053-.317.09-.639.09-.971a6.115 6.115 0 0 0-12.229 0c0 .339.039.667.094.991L4.657 9.12zm6.4 3.523a1.046 1.046 0 0 1-.487.183c-.857.083-1.936.197-2.503.197-.561 0-1.627-.113-2.478-.196a1.048 1.048 0 0 1-.45-.16l-1.506-.539c.933 2.04 2.593 3.311 4.443 3.311 1.854 0 3.517-1.275 4.448-3.321l-1.467.525zm.537-2.903-.165 2.134 1.38-.493c.034-.099.077-.191.108-.293l.046-.145h.152c.579 0 1.059-.922 1.059-2.043 0-.199-.034-.387-.075-.562L11.594 9.74z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }